import {
  Checkbox, Collapse, FormControlLabel, Grid,
} from '@material-ui/core';
import React from 'react';
import CustomTextField from '../../../CustomTextField';

const GOOGLE_TAG_MANAGER = {
  placements: [
    {
      value: 'builder_home',
      label: 'Builder home page',
    },
    {
      value: 'choose_tour',
      label: 'Tour selection page',
    },
    {
      value: 'choose_community',
      label: 'Community selection page',
    },
    {
      value: 'enter_property',
      label: 'Enter property page',
    },
    {
      value: 'community',
      label: 'Community page',
    },
    {
      value: 'property',
      label: 'Property page',
    },
  ],
};

type Props = {
  containerId: string;
  placements: string;
  isActive: boolean;
  handleChangeClient: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const GoogleTagManagerAttributes: React.FC<Props> = ({
  containerId,
  placements,
  isActive,
  handleChangeClient,
}) => {
  let selectedPlacements: string[] = [];

  try {
    const parsedPlacements = JSON.parse(placements || '[]');
    selectedPlacements = Array.isArray(parsedPlacements) ? parsedPlacements : [];
  } catch (e) {
    selectedPlacements = [];
  }

  const handlePlacementChange = (placement: string, checked: boolean) => {
    let newPlacements = selectedPlacements.filter(value => value !== placement);

    if (checked && !selectedPlacements.includes(placement)) {
      newPlacements = [...selectedPlacements, placement];
    } else if (checked) {
      newPlacements = selectedPlacements;
    }

    handleChangeClient({
      target: {
        name: 'GTM Placements',
        value: JSON.stringify(newPlacements),
      },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <Collapse in={isActive}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label="GTM ID"
            name="GTM ID"
            value={containerId || ''}
            onChange={handleChangeClient}
            helperText="Example: GTM-ABCDEFGH"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {GOOGLE_TAG_MANAGER.placements.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              control={(
                <Checkbox
                  checked={selectedPlacements.includes(value)}
                  onChange={(event) => handlePlacementChange(value, event.target.checked)}
                />
              )}
              label={label}
            />
          ))}
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default React.memo(GoogleTagManagerAttributes);
